import { Button } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { useSessionContext } from 'supertokens-auth-react/recipe/session';

import { LogoHeader } from 'src/Components/Shared/LogoHeader';
import { useAcceptInvitation } from 'src/Hooks/Mutations/useAcceptInvitation';
import useValidateInvitation from 'src/Hooks/Queries/useValidateInvitation';

import styles from './InvitationPage.module.scss';

const InvitationPage = () => {
  const session = useSessionContext();
  const { t } = useTranslation();

  const { token } = useParams();

  const { data: invitation, isError } = useValidateInvitation(token);

  const { mutate: acceptInvitation } = useAcceptInvitation({
    onSuccess: () => navigate('/', { state: { showWelcome: true } }),
  });
  const navigate = useNavigate();

  const handleAcceptInvitation = async () => {
    if (!session.loading) {
      if (session.doesSessionExist) {
        if (token) acceptInvitation(token);
      } else {
        navigate(`/auth?returnUrl=${encodeURIComponent(`/invitations/accept/${token}`)}`);
      }
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.subcontainer}>
        <LogoHeader />
        {isError ? (
          <Button className={styles.button} onClick={() => navigate(`/auth`)}>
            {t('invitationPage.signInOrRegister', `Se connecter / Créer un compte`)}
          </Button>
        ) : (
          <>
            <div className={styles.title}>
              {t('invitationPage.title', `Invitation à rejoindre`)} {invitation?.asset.name}
            </div>
            <div className={styles.subtitle}>
              {t('invitationPage.invitedBy', `Vous avez été invité par `)}
              {[invitation?.invitedBy.firstName, invitation?.invitedBy.lastName].join(' ')}
            </div>

            {!session.loading && session.doesSessionExist ? (
              <Button onClick={handleAcceptInvitation}>
                {t('invitationPage.accept', `Accepter l'invitation`)}
              </Button>
            ) : (
              <>
                <div className={styles.subtitle}>
                  {t(
                    'invitationPage.pleaseConnect',
                    `Connectez-vous ou créez un compte pour accéder au bien :`
                  )}
                </div>
                <Button
                  onClick={() =>
                    navigate(
                      `/auth?returnUrl=${encodeURIComponent(`/invitations/accept/${token}`)}`
                    )
                  }
                >
                  {t('invitationPage.signInOrRegister', `Se connecter / Créer un compte`)}
                </Button>
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default InvitationPage;
